export enum WorkshopStatus {
  Scheduled = 1,
  Complete = 2,
}